export default class Behav {
    constructor() {
        this.behaviors = {};
    }

    add(behavior, topic = 'load', args = []) {
        if (!this.behaviors[topic]) {
            this.behaviors[topic] = [];
        }
        // Stocke le comportement avec les arguments optionnels
        this.behaviors[topic].push({ behavior, args });
    }

    apply(selector, topic = 'load') {
        const elements = $(selector);
        if (this.behaviors[topic]) {
            this.behaviors[topic].forEach(({ behavior, args }) => {
                // Passe les �l�ments et les arguments optionnels � la fonction de comportement<
                behavior(elements, ...args);
            });
        }
    }
}
